export const debtConsolidationData = [
  {
    id: 1,
    heading: "Debt Consolidation Calculator: Simplify Your Repayments",
    subHeading:
      "Managing multiple debts can be overwhelming. Minemi’s Debt Consolidation Calculator helps you combine various debts into a single, manageable loan, potentially reducing your EMI burden and streamlining your financial obligations.",
    notice:
      "The results provided are for informational purposes only. Actual loan terms will depend on the lender’s evaluation and your credit profile",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];

export const stepsOfDebtConsolidation = [
  {
    id: "step-one",
    stepName: "Understand Debt Consolidation",
  },
  {
    id: "step-two",
    stepName: "Evaluate Your Financial Situation",
  },
  {
    id: "step-three",
    stepName: "Identify Debts Eligible for Consolidation",
  },
  {
    id: "step-four",
    stepName: "Use Minemi’s Debt Consolidation Calculator",
  },
  {
    id: "step-five",
    stepName: "Compare Consolidation Loan Offers",
  },

  {
    id: "step-six",
    stepName: "Apply for a Debt Consolidation Loan",
  },
  {
    id: "step-seven",
    stepName: "Close Existing Debts",
  },
  {
    id: "step-eight",
    stepName: "Manage Your New Loan Effectively",
  },
  {
    id: "step-nine",
    stepName: "Monitor Your Credit Score",
  },
];
